export default {"src":"/_next/static/media/ic-drag.7624dac5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};